<template>
	
  <div class="home">
<div class="works-ban">
	
		<p> 
 MEMBER CENTER       </p>
	</div>
   <div class="mem-full">
 <Center title='1' />
	
<div class="mem-con">
	<div class="cen-ord">
		<div class="address">
			<div class="men-l1" >
				<div class="re-tit">
						   <h4>Order overview</h4>
				</div>
				<div class="re-con"  >
						<el-row>
							<el-col span="10">
								order number: {{news.orderId}}
							</el-col>
							<el-col span="6">
								Status: {{news.statusInfo}}
							</el-col>
							<el-col span="8">
								Order time : {{news.dtTime}}
							</el-col>
						</el-row>	
						<div class="pass-step">
						<el-steps :active="active"   align-center>
						       <el-step title="To be paid">
						     <img v-if="active==-5" src="../../assets/ic1.png" slot="icon"/>
						 
						        
						       </el-step>
						       <el-step title="To be delivered">  <img v-if="active==2" src="../../assets/ic1.png" slot="icon"/>
						
							 </el-step>
						       <el-step title="Goods to be received"> <img v-if="active==3" src="../../assets/ic1.png" slot="icon"/>
						  </el-step>
							 <el-step title="Goods received"> <img v-if="active==4" src="../../assets/ic1.png" slot="icon"/>
							</el-step>
							
						     </el-steps>
							</div>
							<div class="ord-tip1" v-if="active==-5">
						<div><img src="../../assets/tip1.png" /></div>		The order has not been paid. If the payment is not made within 30 minutes, it will be cancelled automatically
							</div>
							<div class="ord-sim">
							<el-row gutter="20">
								<el-col span="5" class="lt">
									 Order amount:
								</el-col>
								<el-col span="19">
									$ {{news.price}}(including freight $  {{news.yunfei}})
								</el-col>
							</el-row>
							<el-row gutter="20">
								<el-col span="5" class="lt">
									Receiving information:  
								</el-col>	
								<el-col span="10">
							
										{{news.shouhuo_info.name}} {{news.shouhuo_info.address}}
								</el-col>
								<el-col span="9">
															
									<div class="h-button but2" v-if="news.status==-5||news.status==2" @click="ride=true">Change address</div>
								</el-col>
								
							</el-row>
							<el-row gutter="20">
								<el-col span="5" class="lt">
									 Payment method: 
								</el-col>
								<el-col span="19">
								<div v-if="news.pay_info.jifen">
								integral
								</div>
								<div v-if="news.pay_info.weixin">
									weixin
								</div>
								<div v-if="news.pay_info.alipay">
									alipay
								</div>
								<div v-if="news.pay_info.paypal">
									paypal
								</div>
								</el-col>
							</el-row>
							</div>
							<div class="ord-tip1">
							<div><img src="../../assets/tip.png" /></div>Tracking code:  <span v-if="news.fahuo_info.length>0">{{news.fahuo_info[0].company}}  {{news.fahuo_info[0].order_id}}</span>
								</div>
								
								<div class="add-for" v-if="ride">
								<div class="add-tit">
									<p>Modify  Address <span v-if="news.status==2">(update only once)</span></p>
										<div class="h-button but2" @click="submitForm('ruleForm')">Determine</div>
								</div>
								<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"  label-position="top"  size="mini">
									<el-row :gutter="20">
										 <el-col :span="12">
								  <el-form-item label="First name" prop="first_name">
								    <el-input v-model="ruleForm.first_name"></el-input>
								  </el-form-item>
								  </el-col>
								  <el-col :span="12">
								  <el-form-item label="Last name" prop="last_name">
								    <el-input v-model="ruleForm.last_name"></el-input>
								  </el-form-item>
								  </el-col>
								 </el-row>
								 
								<el-row :gutter="20">
								 			 <el-col :span="12">
								<el-form-item label="Country / Region"  prop="country">
								   <el-select v-model="ruleForm.country" placeholder="Please fill in Country"  @change="country">
								     <el-option v-for="item in sun" :label="item.NAME" :value="item.NAME"></el-option>
									  
								   </el-select>
								 </el-form-item>
								  </el-col>
								  <el-col :span="12">
								  <el-form-item label="ID" prop="identity_id">
								    <el-input v-model="ruleForm.identity_id" placeholder="China,Hong Kong,Macao and Taiwan must fill in the ID card number"></el-input>
								  </el-form-item>
								  </el-col>
								 </el-row>
								 
								 <el-row :gutter="20">
								 			 <el-col :span="12">
								  <el-form-item label="Place of residence" prop="address_info">
								    <el-input v-model="ruleForm.address_info"></el-input>
								  </el-form-item>
								  </el-col>
								  <el-col :span="12">
								  <el-form-item label="Detailed address" prop="address_line" >
								    <el-input v-model="ruleForm.address_line"></el-input>
								  </el-form-item>
								  </el-col>
								 </el-row>
								 
								 <el-row :gutter="20">
								 			 <el-col :span="12">
								  <el-form-item label="Phone" prop="phone">
								    <el-input v-model="ruleForm.phone"></el-input>
								  </el-form-item>
								  </el-col>
								  <el-col :span="12" v-if="korean">
								  <el-form-item label="Customs clearance code or date of birth" prop="korean_code" >
								    <el-input v-model="ruleForm.korean_code"></el-input>
								  </el-form-item>
								  </el-col>
								 </el-row>
								 
								 
							
						
						
								
								 <el-row>
							
								  </el-row>
								 <el-row :gutter="20">
								
								 </el-row>
								 
							
								 
								 
								  </el-form-item>
								</el-form>
								
								</div>
							
				</div>
			</div>
			
		</div>
		  <div class="address">
		  	<div class="men-l1" >
		  		<div class="re-tit">
		  				   <h4>Commodity list</h4>
		  		</div>
		  		<div class="re-con"  >
					
							  <div class="cen-ord1">
								  <el-row>
									  <el-col span="10">
					product</el-col>
					<el-col span="5">  price  </el-col>
					<el-col span="4"> number </el-col>
					<el-col span="5"> Subtotal</el-col>
								  </el-row>
							  </div>
					<el-row v-for="it in news.products">
						
									  <el-col span="10">
									 <el-row gutter='10'  class="mem-con-it">
											  <el-col span="10">
												  <img class="cen-ord2" :src="it.image" />
											  </el-col>
											  <el-col span="14">
											  		<div>{{it.title}}</div>
												
											  </el-col>
										  </el-row>
				</el-col>
					<el-col span="5"> $ {{it.price_sale}} </el-col>
					<el-col span="4">
						{{it.num}}
					</el-col>
				<el-col span="5">
					{{it.price_sale*it.num}}
				</el-col>
								  </el-row>
								  
								  
							<div class="ord-info">
								<el-row gutter="10">
									<el-col span="21" class="os">{{news.products.length}} items in total Amount of money:</el-col>
									<el-col span="3">$ {{fin}}</el-col>
								</el-row>
								<el-row gutter="10">
									<el-col span="21" class="os">Freight:</el-col>
									<el-col span="3">$ {{news.yunfei}}</el-col>
								</el-row>
								
								<el-row gutter="10">
									<el-col span="21" class="os">Integral:</el-col>
									<el-col span="3">$ {{news.pay_info.jifen}}</el-col>
								</el-row>
								<el-row gutter="10">
									<el-col span="21" class="os">Coupon:</el-col>
									<el-col span="3">$ {{news.pay_info.yhq}}</el-col>
								</el-row>
								<el-row gutter="10">
									<el-col span="21" class="os"><b>Order amount:</b></el-col>
									<el-col span="3"><b>$ {{news.price}}</b></el-col>
								</el-row>
							</div>
							<div class="ord-int">
								<div class="h-button" v-if="news.status==-5" @click="sandRed">payment</div>
								<!-- <div class="h-button but2" v-if="news.status==-5" @click="cancel">Cancel order</div> -->
								<div class="clear"></div>
							</div>
		  		</div>
		  	</div>
	
		  </div>
	</div>



</div>
   </div>

    </div>
</template>
<script>

import Center from '@/components/center/center'

export default {
  components: {
   Center


  },
  data() {
    return {
		page:1,
		pagenum:100,
		moren:false,
		activeName: '0',
		sun:'',
		active:1,
		id:'',
		total:'',
		fin:0,
		news:'',
		ride:false,
		korean:false,
           ruleForm: {
			id:'',
           	first_name:'',
           	last_name:'',
           	phone:'',
           	country:'',
           	address_info:'',
           	address_line:'',
           	korean_code:'',
			identity_id:''
          
               
                 },
                 rules: {
                 	
                 	   first_name: [
                 	    { required: true, message: 'Please fill in First name', trigger: 'blur' },
                 ],last_name: [
                 	    { required: true, message: 'Please fill in Last name', trigger: 'blur' },
                 ],phone: [
                 	    { required: true, message: 'Please fill in Phone', trigger: 'blur' },
                 ],country: [
                 	    { required: true, message: 'Please fill in Country', trigger: 'change' },
                 ],address_line: [
                 	    { required: true, message: 'Please fill in Detailed address', trigger: 'blur' },
                 ],address_info: [
                 	    { required: true, message: 'Please fill in Place of residence', trigger: 'blur' },
                 ]
                  
                   }
          };
  },  mounted() {
	  
	  this.id = this.$route.query.id
		this.ruleForm.id=this.id
		this.sandMate();
		this.sandCase();
		},methods: {
			
		 submitForm(formName) {
		
			      
			      if(this.ruleForm.country=='China'||this.ruleForm.country=='Hong Kong, China'||this.ruleForm.country=='Taiwan, China'||this.ruleForm.country=='Macao, China'){
			      					  if(this.ruleForm.identity_id==''){
			      					  						   this.ins=true
			      					  }else{
			      									    this.ins=false
			      								  }
			      				
			      }
			      
			      if(this.ins){
			      					  this.$message.error("Please fill in the ID card number.");
			      									  return
			      }
			      	
		        this.$refs[formName].validate((valid) => {
		          if (valid) {
		         this.$axios({
		           method: "post",
		           url: "service.php?action=orders_editAddress",
		           data: this.ruleForm,  
		         }).then((res) => {
		         	let data=res.data;
		         			
		         	if(data.code==1){
						
					this.$message.success(data.message);
					this.sandMate()
					this.ride=false
		         	}else{  
						this.$message.error(data.message);
						      this.ride=false
					}
		          
		         });
				 
				 
		          } else {
		           
		            return false;
		          }
		        });
		      },
			  full(){
				  if(this.moren){
					  this.ruleForm.moren= 1
				  }else{
					   this.ruleForm.moren= 0
				  }
			
			  },
			  sandRed(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=paypal_pay",
			  	  data: {order_id:this.id},  
			  	}).then((res) => {
			  		let data=res.data;
			  
			  		if(data.code==1){
			  			window.open(data.data.link)
			  				
			  		}
			  	 
			  	});
			  
			  },
			 sandCase(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=userAddress_country",
			  	  data: {},  
			  	}).then((res) => {
			  		let data=res.data;
			  	
			  		if(data.code==1){
			  			this.sun=data.data;
			  		}
			  	 
			  	});
			  
			  },pick(item){
							this.page=item;
							this.sandMate()
						},
			 sandMate(){
			 	this.$axios({
			 	  method: "post",
			 	  url: "service.php?action=orders_detail",
			 	  data: {id:this.id},  
			 	}).then((res) => {
			 		let data=res.data;
			 
			 		if(data.code==1){
			 	
			 							
			 			this.news=data.data;
						this.news.products.forEach((item,index)=>{
							this.fin+=item.price_sale*item.num
						})
						this.fin=Number(this.fin).toFixed(2)
						this.active=data.data.status
			 			this.total=data.count
						this.ruleForm.first_name=data.data.shouhuo_info.info.first_name
						this.ruleForm.last_name=data.data.shouhuo_info.info.last_name
						this.ruleForm.country=data.data.shouhuo_info.info.country
						this.ruleForm.identity_id=data.data.shouhuo_info.info.ID
						this.ruleForm.address_info=data.data.shouhuo_info.info.所在地区
						this.ruleForm.address_line=data.data.shouhuo_info.info.详细地址
						this.ruleForm.phone=data.data.shouhuo_info.info.手机号
						this.ruleForm.korean_code=data.data.korean_code
						if(this.ruleForm.country=='South Korea'){
														
							this.korean=true
									   				
						}
			 			
			 		}
			 	 
			 	});
			 
			 },	   country(){  
			   				  if(this.ruleForm.country=='South Korea'){
								
			   					this.korean=true
			   				
			   				  }
							  
							  
							  if(this.ruleForm.country=='China'||this.ruleForm.country=='Hong Kong, China'||this.ruleForm.country=='Taiwan, China'||this.ruleForm.country=='Macao, China'){
							  								
							  			   					  if(this.ruleForm.identity_id==''){
							  									
							  			   					  						   this.ins=true
							  			   					  }else{
							  			   									    this.ins=false
							  			   								  }
							  			   				
							  }
			   }, cancel(){
			  	this.$axios({
			  	  method: "post",
			  	  url: "service.php?action=orders_qxOrder",
			  	  data: {order_id:this.id},  
			  	}).then((res) => {
			  		let data=res.data;
			  
			  		if(data.code==1){
			  			
			  		this.$message.success(data.message);
			  			this.sandMate();
						this.ride=false
			  		}else{  
			  			this.$message.error(data.message);
			  			      
			  		}
			  	 
			  	});
			  
			  },
		      resetForm(formName) {
		        this.$refs[formName].resetFields();
		      }, handleClick() {
				  this.sandMate()
      
      }
		}
};
</script>
<style lang="scss" scoped>
	
	.h-button{
			text-align: center;
			cursor: pointer;
			width: 136px;
			height: 30px;
			line-height:30px;
			background: #000;
			color: #FFFFFF;
			float: right;
			margin-left: 30px;

		}
		.h-button:hover{
			background-color: #333333;
		}
		.but2{
			background: #E8E8E8;
			color: #0A0A0A;
		}
		.but2:hover{
		
			color: #FFFFFF;
		}
	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 50px;
			h4{
				font-size: 26px;
				
			}
			margin-bottom: 20px;
		}
	}	
.login-r1{

}
.login-r2{
	width:490px;

	padding: 50px;
	float: left;

}
.address{
	.re-con{
		font-size: 15px;
		.pass-step{
			margin: 50px 0;
		}
		.ord-sim{
			margin-top: 30px;
			line-height: 30px;
			font-size: 15px;
			color: #484848;
			margin-bottom: 20px;
			.lt{
				text-align: right;
			}
		}
		.ord-tip1{
			display: flex;
			align-items: center;
			background: #D2D2D2;
			padding: 6px 15px;
			color: #0A0A0A;
			img{
				margin-right: 10px;
			}
		}
		li{
			width: 374px;
			height: 190px;
			background: #F8F8F8;
			border: 1px solid #D2D2D2;
			float: left;
			margin-right: 23px;
			margin-bottom: 20px;
			.l1{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px dotted #DDDDDD;
				padding: 0 20px;
			}
.l2{
			
				height: 50px;
				
				border-bottom: 1px dotted #DDDDDD;
				padding:15px 20px;
			}
			.l3{
				display: flex;
				height: 50px;
				justify-content: space-between;
				align-items: center;
		
				padding: 0 20px;
			}
		}
		.plus{
			display: flex;
			flex-direction:column ;
			justify-content: center;
			align-items: center;
			img{
				width: 33px;
				height: 33px;
			}
		}
	}
}

	.works-ban{
		font-family: 'Arial-BoldMT';
		padding-top: 15px;
		background: #0A0A0A;
		height: 57px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		font-weight: bold;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
			color: #B5B5B5;
		}
		.acts{
			color: #FFFFFF;
			font-weight: bolder;
		}
	}
.member{
	width: 247px;
	height: 687px;
	background: #F8F8F8;
	padding: 30px;
	h5{
		line-height: 50px;
		background: url(../../assets/bot1.png) no-repeat bottom left;
	}
	.con{
		li{
			border-bottom:1px solid #eeeeee;
			padding: 20px;
		}
		h6{
			line-height: 40px;
		}
		p{
			display: flex;
			line-height: 40px;
			align-items: center;
			color: #777777;
			span{
				display: inline-block;
				width: 6px;
				height: 6px;
				background: #636363;
				border-radius: 50%;
				margin-right: 10px;
			}
		}
		.act{
			color: #000000;
		}
	}

}
.mem-full{
	display: flex;
	width: 1200px;
	margin: 20px auto;
}

.mem-con{
	flex: 1;
	margin-left: 20px;
	.men-l1{
		border: 1px solid #D2D2D2;
		margin-bottom: 20px;
		.re-tit{
			line-height: 50px;
			border-bottom: 1px solid #D2D2D2;
			h4{
				margin-left: 20px;
			}
			
		}
		.re-con{
			padding: 20px;
		}
	}
}
.add-for{
	margin-top: 30px;
padding: 30px;
	background: #F8F8F8;
	border: 1px solid #D2D2D2;
	.add-tit{
		display: flex;
		justify-content: space-between;
		p{
			font-size: 16px;
			span{
				font-size: 14px;
			}
		}
		margin-bottom: 20px;
	}

}
.add-ship{
	margin: 20px 0;
}
.add-set{
	margin-left: 10px;
}
.cen-ord1{
background: #F8F8F8;
padding: 20px;
margin-bottom: 20px;
}
.cen-ord2{
	width: 100%;
}
.cen-ord3{
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content:space-evenly;
}
	.page{
		text-align: center;
		margin:50px auto;
	}
	.mem-con-it{
		height: 100px;
	}
.ord-info{
	line-height: 30px;
	font-size: 16px;
	.os{
		text-align: right;
	}
}
.ord-int{
	margin: 20px 0;
}
</style>